import React from 'react';
import { Accordion } from 'flowbite-react';
import Image from 'next/image';

const FinTechKeyFocus = () => {
    return (
        <div className="section-py bg-grey">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 pb-30">
                    <div className="lg:col-span-12">
                        <p
                            className="text-primary mb-2.5 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Key Focus Areas to Consider
                        </p>
                        <h2 className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Developing effective strategies for FinTech software development: Key focus areas to consider
                        </h2>
                    </div>
                </div>
                <div className="row items-center grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <Accordion>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Mixed Reality
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Enhance customer education and product demos with immersive AR/VR experiences in
                                                digital banking apps.
                                            </li>
                                            <li>
                                                Use MR for interactive interfaces in wealth management or insurance services,
                                                improving client engagement.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Artificial Intelligence
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Power smarter decision-making with AI-driven fraud detection, credit scoring, and
                                                financial forecasting.
                                            </li>
                                            <li>
                                                Deliver hyper-personalized customer journeys using intelligent algorithms across
                                                mobile banking software.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Technology Integration
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Ensure seamless API integration between payment systems, neobanking services, and
                                                legacy platforms.
                                            </li>
                                            <li>
                                                Build scalable, interconnected ecosystems by leveraging open banking and
                                                third-party fintech APIs.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    BI and Analytics
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Unlock deep financial insights through real-time dashboards and predictive
                                                analytics tools.
                                            </li>
                                            <li>
                                                Use data-driven intelligence to optimize portfolio management, customer
                                                engagement, and compliance reporting.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Digital Commerce
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Enable smooth transactions with digital wallet functionality and embedded payment
                                                processing systems.
                                            </li>
                                            <li>
                                                Add features like loyalty rewards, split payments, and BNPL options to drive new
                                                monetization paths.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Business Automation
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Streamline finance workflows such as loan approvals, invoice management, and
                                                reconciliation with automation.
                                            </li>
                                            <li>
                                                Integrate robotic process automation (RPA) to reduce manual load and increase
                                                processing speed across services.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Blockchain
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        <ul className="list">
                                            <li className="mb-2.5">
                                                Build secure, transparent systems for money transfer services and contract
                                                execution using distributed ledgers.
                                            </li>
                                            <li>
                                                Leverage smart contracts and decentralized finance (DeFi) to innovate financial
                                                transactions and compliance.
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                        </Accordion>
                    </div>
                    <div className="lg:col-span-6 text-center">
                        <Image
                            src="/img/fintech-industry/svg/vector-developing-effective-strategies.svg"
                            alt="key-focus-area"
                            title="key-focus-area"
                            className="img-fluid"
                            height={468}
                            width={595}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FinTechKeyFocus;
